import CaseService from '../../../services/case.service';
import { CaseMessageService } from './types';

/** The body `case/submitcasecomment` expects; mirrors what caseTracker/caseChat.js sends. */
export interface CaseCommentModel {
  CaseId: string;
  PersonnelId: string;
  Message: string;
  CommentedBy: string;
  CommentAttachments: unknown[];
  SendMessageNotification: boolean;
  SendToHubOnly: boolean;
  SendFromOutsideHub: boolean;
  /** Always set: the API reads `Flags.Redesign` without a null check. */
  Flags: { Redesign: boolean; Rescan: boolean };
  isAssistant: boolean;
}

type CommentSubmitter = (model: CaseCommentModel, files: unknown[], patientId: string | undefined, caseId: string) => Promise<Response>;

export function buildCaseCommentModel(caseId: string, personnelId: string, text: string): CaseCommentModel {
  return {
    CaseId: caseId,
    PersonnelId: personnelId,
    Message: text,
    CommentedBy: '',
    CommentAttachments: [],
    SendMessageNotification: false,
    SendToHubOnly: false,
    SendFromOutsideHub: false,
    Flags: { Redesign: false, Rescan: false },
    isAssistant: false,
  };
}

/** Posts as the signed-in dentist, so the message sits on their side of the case chat. Never throws. */
export function createCaseMessageService(
  personnelId: string,
  submit: CommentSubmitter = CaseService.submitCaseComment,
  logger: Pick<Console, 'warn'> = console
): CaseMessageService {
  return {
    async post(caseId, text) {
      if (!caseId || !personnelId || !String(text ?? '').trim()) return { accepted: false };
      try {
        const response = await submit(buildCaseCommentModel(caseId, personnelId, text), [], undefined, caseId);
        if (!response.ok) logger.warn(`[askAi] case message rejected (HTTP ${response.status})`);
        return { accepted: response.ok };
      } catch (error) {
        logger.warn('[askAi] case message failed', error);
        return { accepted: false };
      }
    },
  };
}
